import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import TrainingPage from './TrainingPage';
import MovementSpecialists from './movement-specialists/MovementSpecialists';
import GolfSchools from './golf-schools/GolfSchools';
import SwingSubmittals from './swing-submittals/SwingSubmittals';
import OnlineFollowUp from './online-follow-up/OnlineFollowUp';
import InPersonFollowUp from './in-person-follow-up/InPersonFollowUp';

class Training extends Component {
  render() {
    const { match } = this.props;

    return (
      <div>
        <Helmet>
          <title>Tathata Golf - Coaching</title>
        </Helmet>
        <Switch>
          <Route exact path={`${match.path}/`} component={TrainingPage} />
          <Route exact path={`${match.path}/movement-specialists`} component={MovementSpecialists} />
          <Route exact path={`${match.path}/online-follow-up`} component={OnlineFollowUp} />
          <Route exact path={`${match.path}/in-person-follow-up`} component={InPersonFollowUp} />
          <Route path={`${match.path}/golf-schools`} component={GolfSchools} />
          <Route path={`${match.path}/swing-submittals`} component={SwingSubmittals} />
          <Redirect to={match.path} />
        </Switch>
      </div>
    );
  }
}

export default Training;



// WEBPACK FOOTER //
// ./src/subscription/coaching/Training.js